
import { FETCH_ALL, ADD_NEW, UPDATE, DELETE, GET_INVOICE, START_LOADING, END_LOADING, FETCH_INVOICE_BY_USER, FETCH_DELETED_INVOICES, RESTORE_INVOICE, PERMANENT_DELETE_INVOICE } from '../actions/constants'

const CACHE_TTL = 5 * 60 * 1000

const initialState = {
    isLoading: true,
    invoices: [],
    deletedInvoices: [],
    byId: {},
    allIds: [],
    lastFetched: null,
    lastQuery: null,
    invoice: null,
    pendingQuery: null,
    currentPage: 1,
    numberOfPages: 1,
}

const buildStateFromInvoices = (list = []) => {
    const byId = {}
    const allIds = []
    list.forEach((inv) => {
        if (inv?._id) {
            byId[inv._id] = inv
            allIds.push(inv._id)
        }
    })
    return { byId, allIds, invoices: allIds.map((id) => byId[id]) }
}

const updateSingleInvoice = (state, invoice) => {
    if (!invoice?._id) return state
    const byId = { ...state.byId, [invoice._id]: invoice }
    const allIds = state.allIds.includes(invoice._id)
        ? state.allIds
        : [...state.allIds, invoice._id]
    const invoices = allIds.map((id) => byId[id]).filter(Boolean)
    return { ...state, byId, allIds, invoices }
}

const invoices = (state = initialState, action) => {
    switch (action.type) {
      case START_LOADING:
        return { ...state, isLoading: true, pendingQuery: action.meta?.cacheKey ?? state.pendingQuery };
      case END_LOADING:
        return { 
          ...state, 
          isLoading: false,
          pendingQuery: action.meta?.cacheKey && state.pendingQuery === action.meta.cacheKey
            ? null
            : state.pendingQuery,
        };
      case FETCH_ALL: {
        const normalized = buildStateFromInvoices(action.payload?.data || [])
        return {
          ...state,
          invoices: normalized.invoices,
          byId: normalized.byId,
          allIds: normalized.allIds,
          currentPage: action.payload?.currentPage,
          numberOfPages: action.payload?.numberOfPages,
        };
      }
      case FETCH_INVOICE_BY_USER: {
        const { data, cacheKey, fetchedAt = Date.now() } = action.payload || {}
        const normalized = buildStateFromInvoices(data || [])
        return {
            ...state,
            invoices: normalized.invoices,
            byId: normalized.byId,
            allIds: normalized.allIds,
            lastFetched: fetchedAt,
            lastQuery: cacheKey || null,
        }
      }

      case GET_INVOICE:
        return { ...state, invoice: action.payload };
      case ADD_NEW:
        return updateSingleInvoice(state, action.payload);
      case UPDATE:
        return updateSingleInvoice(state, action.payload);
      case DELETE: {
        const deleteId = action.payload
        const byId = { ...state.byId }
        delete byId[deleteId]
        const allIds = state.allIds.filter((id) => id !== deleteId)
        const invoices = allIds.map((id) => byId[id]).filter(Boolean)
        return { ...state, byId, allIds, invoices }
      }
      case FETCH_DELETED_INVOICES:
        return { ...state, deletedInvoices: action.payload };
      case RESTORE_INVOICE:
        return { ...state, deletedInvoices: state.deletedInvoices.filter((invoice) => invoice._id !== action.payload._id) };
      case PERMANENT_DELETE_INVOICE:
        return { ...state, deletedInvoices: state.deletedInvoices.filter((invoice) => invoice._id !== action.payload) };
      default:
        return state;
    }
  };

  export default invoices



//   const invoices =( state = { invoices: [], }, action ) => {
//     switch (action.type) {
//         case FETCH_ALL:
//             return { ...state, invoices: action.payload }

//         case GET_INVOICE:
//             return { ...state, invoice: action.payload }

//         case ADD_NEW:
//             return { ...state, invoices: [...state.invoices, action.payload] }

//         case UPDATE:
//             return { ...state, invoices: state.invoices.map((invoice) => invoice._id === action.payload ? action.payload : invoice) }
        
//         case DELETE: 
//         return {...state, invoices: state.invoices.filter((invoice) => invoice._id !== action.payload)}
        
//         default:
//             return state;
//     }
// }

// export default invoices
